import { AppDivider } from 'components/core/AppDivider/AppDivider';
import { AppLinkRoot } from 'components/core/AppLink/AppLink';
import Grid from 'components/core/Grid';
import { LoadingButton } from 'components/core/LoadingButton/LoadingButton';
import { FormikAppEmail } from 'components/formik/core/FormikAppEmail/FormikAppEmail';
import { FormikAppTextField } from 'components/formik/core/FormikAppTextField/FormikAppTextField';
import { AppRoutes } from 'config/appRoutes';
import { Button, Typography } from '@mui/material';
import { useIsMutating } from 'react-query';
import { LoginModeEnum } from 'components/views/pages/login/types';
import { LoginFormFooter } from 'components/views/pages/login/LoginFormFooter';
import { useFormikContext } from 'formik';
import { ChevronRight } from '@mui/icons-material';

export interface LoginFormProps {
  mode: LoginModeEnum;
  hasLoginFormFooter?: boolean;
  hasTopAppDivider?: boolean;
  isEmailFieldDisabled?: boolean;

  onClickForgotPassword?: () => void;
}

export const LoginForm = ({
  mode,
  hasLoginFormFooter = true,
  hasTopAppDivider = true,
  isEmailFieldDisabled = false,
  onClickForgotPassword = undefined,
}: LoginFormProps) => {
  const { errors } = useFormikContext<any>();
  const mutationCount = useIsMutating();
  const isMutating = mutationCount > 0;

  return (
    <Grid container spacing={2}>
      {hasTopAppDivider ? (
        <Grid item xs={12}>
          <AppDivider />
        </Grid>
      ) : null}
      <Grid item xs={12}>
        <FormikAppEmail name="email" disabled={isEmailFieldDisabled} />
      </Grid>
      <Grid item xs={12}>
        <FormikAppTextField name="password" label="Password" isPasswordField={true} />
      </Grid>
      <Grid item xs={12}>
        {errors.submit ? <Typography color="red">{errors.submit} </Typography> : <></>}
      </Grid>
      <Grid item xs={12} align="right">
        {onClickForgotPassword ? (
          <Button color="secondary" size="small" onClick={onClickForgotPassword}>
            Forgot Password?
          </Button>
        ) : (
          <AppLinkRoot href={AppRoutes.forgotPassword}>Forgot Password?</AppLinkRoot>
        )}
      </Grid>
      <Grid item xs={12}>
        <LoadingButton isLoading={isMutating} text="Log In" isFullWidth isFormikButton size="large" endIcon={<ChevronRight />} />
      </Grid>

      {hasLoginFormFooter ? <LoginFormFooter mode={mode} /> : null}
    </Grid>
  );
};
